import * as React from 'react';

import SignatureBox from './SignatureBox';

class Agreement extends React.Component {
  render() {
    return (
      <div className="SignatureWrapper"> 
        <div className="alert-message">
          <SignatureBox inputName="job[giftaid_signature]" />
        </div>
      </div>
    );
  }
}


type Props = {
  status: string,
  collection_address: {
    line_1: string,
    line_2: string,
    city: string,
    postal_code: string,
  }
}

type State = {
  status: string,
  addressMode: 'same' | 'different',
  differentAddress: {
    line_1: string,
    line_2: string,
    city: string,
    postal_code: string,
  }
}


class WidgetGiftaid extends React.Component<Props, State> {
  state: State = {
    status: this.props.status,
    addressMode: 'same',
    differentAddress: {
      line_1: '',
      line_2: '',
      city: '',
      postal_code: '',
    },
  };

  onChangeStatus = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      status: e.target.value,
      addressMode: 'same',
      differentAddress: {
        line_1: '',
        line_2: '',
        city: '',
        postal_code: '',
      },
    })
  }

  onChangeAddressMode = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      addressMode: e.target.value as 'same' | 'different',
    });
  }

  onChangeDifferentAddress = (e: React.ChangeEvent<HTMLInputElement>) => {
    const field = e.target.getAttribute('data-field');
    if (field) {
      const value = e.target.value;
      this.setState(prev => ({
        differentAddress: {
          ...prev.differentAddress,
          [field]: value,
        },
      }));
    }
  }

  render() {
    const needsSignature = this.state.status === 'BOXMOVE_ENROLLED';
    const { collection_address } = this.props;
    const { addressMode, differentAddress } = this.state;
    const activeAddress = addressMode === 'same' ? collection_address : differentAddress;

    return (
      <div className="WidgetGiftaid ms-2">
        <div className="mb-3" onChange={this.onChangeStatus}>
          <label>
            <input type="radio" name="job[giftaid_status]" value="BOXMOVE_ENROLLED" id="giftaid_yes" />&nbsp;Yes, add Gift Aid
          </label>
        </div>

        {needsSignature && <div className="my-2"><Agreement /></div>}

        {needsSignature && (
          <div className="my-2 ms-3">
            <h5>What is your home address?</h5>
            <div className="mb-3">
              <label>
                <input
                  type="radio"
                  name="giftaid_address_mode"
                  value="same"
                  defaultChecked
                  onChange={this.onChangeAddressMode}
                />&nbsp;The same as the collection address
              </label>

            {addressMode === 'same' && (
              <div className="text-muted small ms-4 mt-1">
                <div>{collection_address.line_1}</div>
                {collection_address.line_2 && <div>{collection_address.line_2}</div>}
                <div>{collection_address.city}</div>
                <div>{collection_address.postal_code}</div>
              </div>
            )}
            </div>
            <div className="mb-3">
              <label>
                <input
                  type="radio"
                  name="giftaid_address_mode"
                  value="different"
                  onChange={this.onChangeAddressMode}
                />&nbsp;A different address
              </label>
            </div>
            {addressMode === 'different' && (
              <div>
                <div className="row mb-3">
                  <label className="col-sm-3 form-label" htmlFor="giftaid_address_line_1">Address line 1</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      id="giftaid_address_line_1"
                      data-field="line_1"
                      value={differentAddress.line_1}
                      onChange={this.onChangeDifferentAddress}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <label className="col-sm-3 form-label" htmlFor="giftaid_address_line_2">Address line 2</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      id="giftaid_address_line_2"
                      data-field="line_2"
                      value={differentAddress.line_2}
                      onChange={this.onChangeDifferentAddress}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <label className="col-sm-3 form-label" htmlFor="giftaid_address_city">City or town</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      id="giftaid_address_city"
                      data-field="city"
                      value={differentAddress.city}
                      onChange={this.onChangeDifferentAddress}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <label className="col-sm-3 form-label" htmlFor="giftaid_address_postal_code">Postcode</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      id="giftaid_address_postal_code"
                      data-field="postal_code"
                      value={differentAddress.postal_code}
                      onChange={this.onChangeDifferentAddress}
                    />
                  </div>
                </div>
              </div>
            )}
            <input type="hidden" name="giftaid_address[line_1]" value={activeAddress.line_1} />
            <input type="hidden" name="giftaid_address[line_2]" value={activeAddress.line_2} />
            <input type="hidden" name="giftaid_address[city]" value={activeAddress.city} />
            <input type="hidden" name="giftaid_address[postal_code]" value={activeAddress.postal_code} />
          </div>
        )}

        <div className="mb-3" onChange={this.onChangeStatus}>
          <label>
            <input type="radio" name="job[giftaid_status]" value="NOT_INTERESTED" />&nbsp;No, do not add Gift Aid
          </label>
        </div>
      </div>
    );
  }
}

export default WidgetGiftaid;
